import React from 'react';
import { Avatar, Box } from '@mui/material';
import { AppHeroView } from 'components/utils/AppHeroView';
import { AppSectionView } from 'components/utils/AppSectionView';
import mahindra from 'assets/images/partners/mahindra.jpg';
import tata from 'assets/images/partners/tata.jpg';
import shine_motor from 'assets/images/partners/shine_motor.jpg';
import bharat_benz from 'assets/images/partners/bharat_benz.jpeg';
import cargo_motors from 'assets/images/partners/cargo_motors.jpeg';
import urmila from 'assets/images/partners/urmila.jpeg';
import AppLogo from 'components/widgets/AppLogo';
const PartnersPage = () => {

    const partners = [
        { 
            icon: <AppLogo src={mahindra} alt="Mahindra" sx={{width: 48, height: 48}} />,
            title: 'Mahindra and Mahindra Ltd',
            description: 'PAN India Service',
        },
        { 
            icon: <AppLogo src={tata} alt="TATA" sx={{width: 48, height: 48}} />,
            title: 'TATA DLT [ TIVA TRAILERS]',
            description: 'Pune, Jamshedpur, Jaipur',
        },
        { 
            icon: <AppLogo src={bharat_benz} alt="Bharat Benz" sx={{width: 48, height: 48}} />,
            title: 'PPS Trucking',
            description: 'Bhubaneswar, Chandikhol, Berhampur, Keonjhar, Jharsuguda, Rourkela, Cuttack, Angul, Jabalpur, Satna, Singrauli, Chhatarpur, Lucknow, Kanpur, Gourakpur, Prayagraj, Varanasi, Kabrai and Berhampur'
        },
        { 
            icon: <AppLogo src={shine_motor} alt="Bharat Benz" sx={{width: 56, height: 48}} />,
            title: 'Shine Motors',
            description: 'Jamshedpur'
        },
        { 
            icon: <AppLogo src={tata} alt="TATA" sx={{width: 48, height: 48}} />,
            title: 'M/S SAINI MOTER COMPANY',
            description: 'Kangra'
        },
        { 
            icon: <AppLogo src={cargo_motors} alt="Cargo Motors" sx={{width: 48, height: 48}} />,
            title: 'Cargo Motors Pvt Ltd',
            description: 'Jallandhar'
        },
        {
            icon: <AppLogo src={tata} alt="TATA" sx={{width: 48, height: 48}} />,
            title: 'Libra Automobiles Ltd.',
            description: 'Himachal Pradesh, Hoshiarpur and Patiala'
        },
        { 
            icon: <AppLogo src={tata} alt="TATA" sx={{width: 48, height: 48}} />,
            title: 'Krishna Auto Sales',
            description: "Moga, Sangrur"
        },
        { 
            icon: <AppLogo src={tata} alt="TATA" sx={{width: 48, height: 48}} />,
            title: 'Bee Gee Automobiles',
            description: 'Solan'
        },
        { 
            icon: <AppLogo src={tata} alt="TATA" sx={{width: 48, height: 48}} />,
            title: 'ACPL',
            description: 'Kolkata'
        },
        { 
            icon: <AppLogo src={tata} alt="TATA" sx={{width: 48, height: 48}} />,
            title: 'ACGL',
            description: 'Goa'
        },
        { 
            icon: <AppLogo src={tata} alt="TATA" sx={{width: 48, height: 48}} />,
            title: 'Pasco Motors',
            description: 'Chandigarh'
        },
        { 
            icon: <Avatar sx={{ fontSize: 12 }}> Robin </Avatar>,
            title: 'M/s Robin Bordoloi',
            description: 'Assam'
        },
        { 
            icon: <Avatar sx={{ fontSize: 12 }}> Prosenjit </Avatar>,
            title: 'Prosenjit Bhuyan',
            description: 'Assam'
        },
        { 
            icon: <Avatar sx={{ fontSize: 12 }}> Ranajit </Avatar>,
            title: 'Ranajit Bhuyan',
            description: 'Assam'
        },
        { 
            icon: <Avatar sx={{ fontSize: 12 }}> Nirmal </Avatar>,
            title: 'Nirmal Kumar Sharma',
            description: 'Assam'
        },
        { 
            icon: <Avatar sx={{ fontSize: 12 }}> Biswajit </Avatar>,
            title: 'Biswajit Dutta',
            description: 'Assam'
        },
        { 
            icon: <Avatar sx={{ fontSize: 12 }}> PAJSSL </Avatar>,
            title: 'Purana Amulapatty Jubak Samabai Smity Ltd',
            description: 'Assam'
        },
        { 
            icon: <AppLogo src={bharat_benz} alt="TATA" sx={{width: 48, height: 48}} />,
            title: 'Putzmeister (Bharat Benz)',
            description: 'Bangalore'
        },
        { 
            icon: <AppLogo src={urmila} alt="URMILA" sx={{width: 48, height: 48}} />,
            title: 'URMILLA Enterprises Private Limited ',
            description: 'PAN India Service'
        }
    ]

    return (
        <Box>
            {/* Hero Section */}
            <AppHeroView
                title="Our Trusted Partners"
                description="Collaborating with industry leaders to deliver excellence in chassis transport"
            />

            <AppSectionView
                title="Our Partners"
                description="We work with a network of trusted partners to ensure the highest quality of service."
                descriptionProps={{ textAlign: 'center' }}
                items={partners} />
        </Box>
    );
};

export default PartnersPage;
